import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { MasterDataType, AccountcategoryTableDataType, SaveResponseType, AccountCategorySearchParams } from "./types";
import instance from "@services/services";
const { clinicId } = getConstants()
const {MastersApi} = api
export const getAllAccountCategories = async (params:AccountCategorySearchParams):Promise<ResponseType<{categoryResponseDto:AccountcategoryTableDataType[],totalCount:number}>>=>{
    const result = await instance.post(`${MastersApi.getAllAccountCategory}`,{...params,clinicId});
    return result.data;
}

export const deleteMasterData = async (id:number):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.delete(`${MastersApi.deleteAccountCategory}${id}`);
    return result.data;
}

export const saveMasterData = async (params:MasterDataType[]):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.post(`${MastersApi.saveAccountCategory}`,params);
    return result.data;
}

